import '.ak{position:fixed;}.ssr-plugin'
import '.al{inset:0px;}.ssr-plugin'
import '.dx{background:rgba(0,0,0,0.66);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.dy{z-index:99;}.ssr-plugin'
import '.dz{animation-duration:1s;}.ssr-plugin'
import '.e0{animation-effect:ease-in;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.ad{max-width:440px;}.ssr-plugin'
import '.ah{padding:32px;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.e1{margin:24px;}.ssr-plugin'
import '.am{overflow:hidden;}.ssr-plugin'
import '.d4{text-align:center;}.ssr-plugin'
import { styled } from 'inlines'
import { SpinningLoader } from './SpinningLoader'
import { useTheme } from '../providers/useTheme'
import { Text } from './Text'
import { useEffect } from 'react'
import { useTranslations } from '../hooks/useTranslations'
import { capitalize } from '@based/ui'

export const StripeProcessing = ({
  isWaiting,
  isProcessing,
}: {
  isWaiting?: boolean
  isProcessing?: boolean
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  const { colors } = useTheme()
  const { data: dictionary } = useTranslations('checkout')

  return (
    <div className="ak al dx a d c dy"
    >
      <div className="dz e0"
        style={{
          '@keyframes': {
            '0%': {
              opacity: 0,
            },
            '100%': {
              opacity: 1,
            },
          },}}
      />

      <div className="s f ad ah d c d2 e1 am d4"
        style={{
          backgroundColor: colors.background,
          border: `1px solid ${colors.border}`,}}
      >
        <SpinningLoader size={64} style={{ margin: '0 auto' }} />
        <Text
          color="gradient"
          variant="title"
          isMultiline
          style={{ textAlign: 'center', marginBottom: 6, marginTop: 12 }}
        >
          {capitalize(dictionary?.processing_payment ?? '')}
        </Text>
        <Text style={{ textAlign: 'center' }}>
          {capitalize(
            isWaiting || isProcessing
              ? dictionary?.processing_payment_message
              : dictionary?.processing_payment_long_wait,
          )}
        </Text>
      </div>
    </div>
  )
}
